import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { RxdbService } from '../services/rxdb.service';
import { Observable } from 'rxjs';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { GlobalService } from '../services/global.service';
import { sideNavAnimation } from '../side-nav-animation';
import { ApsAssignedList } from '../models/aps-assigned-list';
import { ApsAssignedFacade } from '../ngrx/aps_assinged/aps_assinged.facade';
import { FormDataFacade } from '../ngrx/form-data/form-data.facade';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CheckingOutModalComponent } from '../shared/checking-out-modal/checking-out-modal.component';
import { Network } from '@ngx-pwa/offline';
import * as moment from 'moment';


export interface Report {
  participant_id: number;
  report_date: string;
  case_number: number;
  report_number: number;
  region: string;
  asignee: string;
  aps_client: string;
  perpetrator: string;
  days_open: number;
}

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.scss'],
  animations: [sideNavAnimation]
})
export class ReportListComponent implements OnInit {
  reportList: Array<ApsAssignedList> = [];
  reportList$: Observable<Array<ApsAssignedList>>;
  reportListTemp: Array<ApsAssignedList>;
  multiSelectItems = false;
  selectedIDs: Array<number> = [];
  visible = true;
  checkOutIDS: Array<number> = [];
  bsModalRef: BsModalRef;
  online$ = this.network.online;

  constructor(
    private api: ApiService,
    private rxDB: RxdbService,
    private router: Router,
    private storage: StorageService,
    private global: GlobalService,
    private apsAssignedFacade: ApsAssignedFacade,
    private fdFacade: FormDataFacade,
    private modalService: BsModalService,
    protected network: Network
  ) {
    this.reportList$ = apsAssignedFacade.apsAssignedList$;
  }

  ngOnInit() {
    this.network.onlineChanges.subscribe(
      online => this.online$ = online
    );
    this.visible = this.global.getSideBarVisibility();
    const selectedIDsFromStore = this.storage.getSessionValue('selectedIDs', 'json');
    if (selectedIDsFromStore.length > 0) {
      this.selectedIDs = selectedIDsFromStore;
      this.multiSelectItems = true;
    }
    this.apsAssignedFacade.getApsAssignedList();
    const assignedAgentId = +this.storage.getLocalValue('selectedAssignedAgentId');
    this.apsAssignedFacade.getApsAssignedCheckOutList(assignedAgentId).subscribe(
      doc => {
        this.online$ = this.network.online;
        this.reportList$.subscribe(
          (assignedData: Array<ApsAssignedList>) => {
            const finalList = assignedData.filter(aps => !doc.map(data => +data.aps_report_load_id).includes(+aps.aps_report_load_id));
            this.reportList = finalList;
            this.reportListTemp = finalList;
          }
        );
      }
    );
  }

  searchClient(ev) {
    this.reportList = this.reportListTemp.filter(data => {
      if (!ev.target.value) {
        return this.reportListTemp;
      }
      return data.victim_last_name.toLowerCase().indexOf(ev.target.value.toLowerCase()) !== -1;
    });
  }

  onPress(apsReportLoadId: number) {
    this.multiSelectItems = true;
    this.selectedIDs.push(apsReportLoadId);
  }

  onPressUP() {
    if (!this.checkIfHasIDs()) {
      this.multiSelectItems = false;
    }
  }

  onTap(apsReportLoadId) {
    if (this.multiSelectItems) {
      this.addRemoveSelectedID(apsReportLoadId);
    }

    if (!this.checkIfHasIDs()) {
      this.multiSelectItems = false;
    }
  }

  checkIfHasIDs() {
    return this.selectedIDs.length > 0 ? true : false;
  }

  checkOutList() {
    const checkOutList = this.reportList.filter(data => this.selectedIDs.includes(+data.aps_report_load_id));
    const assignedAgentId = +this.storage.getLocalValue('selectedAssignedAgentId');
    const initialState = {
      checkOutList,
      assignedAgentId
    };
    this.modalService.config.ignoreBackdropClick = true;
    this.bsModalRef = this.modalService.show(CheckingOutModalComponent, {initialState});
    // this.router.navigate(['/checkout-list']);
  }

  addRemoveSelectedID(id) {
    if (this.selectedIDs.includes(id)) {
      this.selectedIDs = this.selectedIDs.filter(selectedId => selectedId !== id);
    } else {
      this.selectedIDs.push(id);
    }
  }

  removeAllSelected() {
    this.selectedIDs = [];
    this.multiSelectItems = false;
    this.storage.removeSessionValue('selectedIDs');
  }

  showHideNav() {
    this.visible = !this.visible;
  }

  onDoubleTap(apsReportLoadId: number) {
    const checkOutList = this.reportList.filter(data => +data.aps_report_load_id === apsReportLoadId);
    const assignedAgentId = +this.storage.getLocalValue('selectedAssignedAgentId');
    checkOutList.map(
      data => {
        data.date_created = moment().format('MM/DD/YYYY HH:mm');
        this.apsAssignedFacade.insertApsAssignedCheckOutItem(data);
        this.fdFacade.fetchFormData(data.aps_report_load_id, assignedAgentId);
      }
    );
    this.storage.setLocalValue('selectedID', apsReportLoadId);
    this.storage.setSessionValue('subSection', 'sectionA');
    this.storage.removeSessionValue('openedSection');
    this.router.navigate(['/intake-reports/section/', 'aps_intake_report', 'sectionA']);
  }

}
